import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import RulePop from '../Pop/RulePop/RulePop.vue';
export default {
  components: {
    Avatar: Avatar,
    RulePop: RulePop
  },
  data: function data() {
    return {
      showRule: false,
      player: null,
      isPlaying: false,
      // 是否开始播放
      isPlayerError: false,
      // 播放器是否错误
      isPlayerPassiveStop: false // 是否被动暂停

    };
  },
  computed: {
    // 当前进行到第几阶段的
    index: function index() {
      var now = this.$store.state.now;
      var list = this.setting.时间线;
      var index = list.findIndex(function (v) {
        return now >= v.开始时间 && now < v.结束时间;
      });
      return index > -1 ? index : 0;
    },
    // 时间轴
    timeLine: function timeLine() {
      var _this = this;

      return this.setting.时间线.map(function (v, k) {
        Object.assign(v, {
          txt: _this.index === k ? v.进行中 : _this.index < k ? v.未开始 : v.已结束
        });
        return v;
      });
    },
    // 当前阶段视频信息
    videoInfo: function videoInfo() {
      return this.setting.时间线[this.index];
    },
    // 是否可以播放
    isCanPlay: function isCanPlay() {
      var _this$videoInfo = this.videoInfo,
          vid = _this$videoInfo.vid,
          livepid = _this$videoInfo.livepid;
      return vid && (this.isDemandPlay ? true : livepid);
    },
    // 是否点播
    isDemandPlay: function isDemandPlay() {
      return [0, 3].indexOf(this.index) > -1;
    },
    // 是否自动播放
    autoplay: function autoplay() {
      return this.page !== 'role';
    }
  },
  methods: {
    // 根据用户处的阶段区分直播或者点播
    // 0、3 点播；1、2直播
    playVideo: function playVideo() {
      // 不可播放直接返回
      if (!this.isCanPlay) return; // 区分直播或点播

      if (this.isDemandPlay) {
        this.playDemandVideo();
      } else {
        this.playLiveVideo();
      }
    },
    // 点播
    playDemandVideo: function playDemandVideo() {
      var _this2 = this;

      // 点播vid
      var vid = this.videoInfo.vid;

      if (this.player) {
        this.player.play(vid);
        return;
      } // 播放器尺寸


      var config = {
        containerId: 'video_wrap',
        vid: vid,
        width: '100%',
        height: '100%',
        playerType: 'h5',
        autoplay: this.autoplay,
        muted: true
      };
      var vm = this;
      vm.player = new window.Txplayer(config);
      vm.player.on('ready', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (vm.player.play) {
                  _context.next = 3;
                  break;
                }

                vm.player = null;
                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return vm.checkWxReady();

              case 5:
                if (_this2.autoplay) {
                  vm.player.play();
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))); // 监听播放开始或者结束

      vm.player.on('playStateChange', function (state) {
        _this2.isPlaying = state === 1;
      }); // 监听广告开始，显示video

      vm.player.on('adStart', function () {
        _this2.isPlaying = true;
      }); // 播放是否错误

      this.player.on('error', function () {
        _this2.isPlayerError = true;
      });
    },
    // 播放直播视频
    playLiveVideo: function playLiveVideo() {
      var _this3 = this;

      var _this$videoInfo2 = this.videoInfo,
          vid = _this$videoInfo2.vid,
          livepid = _this$videoInfo2.livepid;

      if (this.player) {
        this.player.play({
          vid: vid,
          livepid: livepid
        });
        return;
      }

      var config = {
        containerId: 'video_wrap',
        vid: vid,
        livepid: livepid,
        width: '100%',
        height: '100%',
        autoPlayInMute: !env.isWechat && this.autoplay
      };
      this.player = new window.TxvLive(config);
      this.player.on('playing', function () {
        _this3.isPlaying = true;

        _this3.loading.hide();
      }); // 播放是否错误

      this.player.on('error', function () {
        _this3.isPlayerError = true;

        _this3.loading.hide();
      });
      this.player.uistatus.on('statechange', function (state) {
        if (state === 'start') {
          _this3.loading.show();
        }
      });
    },
    // 判断微信的环境中是否OK
    checkWxReady: function checkWxReady() {
      return new Promise(function (resolve) {
        if (env.isWechat) {
          if (window.WeixinJSBridge) {
            window.WeixinJSBridge.invoke('getNetworkType', {}, function () {
              resolve();
            }, false);
          } else {
            document.addEventListener('WeixinJSBridgeReady', function () {
              window.WeixinJSBridge.invoke('getNetworkType', {}, function () {
                resolve();
              });
            }, false);
          }
        } else {
          resolve();
        }
      });
    },
    // 高清点播
    // 去第四个模块的内容
    goToHDDemand: function goToHDDemand() {
      var url = this.setting.时间线[3].跳转链接;

      if (url) {
        this.openUrl(url);
      }
    },
    // 跳转底层页
    jumpBottomPage: function jumpBottomPage() {
      this.openUrl(this.videoInfo.跳转链接);
    },
    // 计算进度条
    calcProcess: function calcProcess() {
      var _this4 = this;

      this.$nextTick(function () {
        // 获取容器宽度
        var contW = document.getElementById('player').offsetWidth;
        var progressDom = document.querySelector('.progress'); // 获取当前点亮的时间线的长度

        var dom = progressDom.getElementsByClassName('progress_item active');
        var lineW = Array.prototype.slice.call(dom).reduce(function (total, cur) {
          return total + cur.offsetWidth;
        }, 0); // 获取最后点亮项的文本的宽度

        var txtW = progressDom.querySelectorAll('.txt')[_this4.index].clientWidth / 2; // 便宜距离，大于 0 时进行便宜

        var len = lineW + txtW - contW;
        var progress = _this4.$refs.progress;
        progress.scroll({
          left: len > 0 ? len : 0,
          top: 0
        });
      });
    },
    // 监听视频播放或者停止
    listenVideo: function listenVideo() {
      var _this5 = this;

      // 监听视频暂停事件
      this.eventBus.$on('stopVideo', function () {
        if (_this5.isPlayerError || !_this5.isPlaying) {
          return;
        }

        _this5.isPlayerPassiveStop = true;
        _this5.isPlaying = false;

        if (_this5.isDemandPlay) {
          _this5.player.pause();
        } else {
          _this5.player.stopVideo();
        }
      }); // 监听继续视频播放

      this.eventBus.$on('playVideo', function () {
        // 非被动终止播放，不用继续播放
        if (!_this5.isPlayerPassiveStop || _this5.isPlayerError) {
          return;
        }

        _this5.isPlayerPassiveStop = false;

        _this5.player.play();
      });
    }
  },
  mounted: function mounted() {
    if (this.page === 'live') return; // 播放视频

    this.playVideo(); // 计算进度条

    this.calcProcess(); // 设置监听

    this.listenVideo();
  }
};